// M8.1 navigation IA — one global switch.
//
// Env var: VITE_NAV_IA_V2_ENABLED. Strict `=== 'true'`, default OFF.
// Unset, 'false', 'TRUE', '1', 'yes', and whitespace all stay OFF.
//
// Mark, 2026-10-30 (OQ-M7-3 / OQ-S6): big-bang. When the flag is on,
// every session sees the /v2 groups. There is no per-workspace,
// per-tenant, or localStorage rollout. When it is off, Sidebar renders
// the unprefixed nav and App.tsx routes are unchanged.
//
// ADR-007 (liquidretail_backend docs/adr) was not readable from this
// repo (HTTP 404 on 2026-10-30). The group list follows Mark's nav
// comment on PR #130 and the M7/M8 amendment §4.8.

export const PLANS_VERSIONS_PATH = '/v2/plans/versions';
export const CATALOG_LIBRARY_PATH = '/v2/catalog/library';

export function isNavIaV2Enabled(
  env: { VITE_NAV_IA_V2_ENABLED?: string } = import.meta.env
): boolean {
  return env.VITE_NAV_IA_V2_ENABLED === 'true';
}

// Child of Plans. Not a top-level nav item. PR #146 ships the
// navigator at /v2/versions; this shell links /v2/plans/versions
// instead and does not add a tenth primary or secondary entry.
export function isVersionsV2Enabled(
  env: { VITE_VERSIONS_V2_ENABLED?: string } = import.meta.env
): boolean {
  return env.VITE_VERSIONS_V2_ENABLED === 'true';
}

// Child of Catalog. The library page stays unregistered until the
// OQ-M7-5 mini-spec is accepted. The nav link is the only client
// of this flag in this PR.
export function isLibraryV2Enabled(
  env: { VITE_LIBRARY_V2_ENABLED?: string } = import.meta.env
): boolean {
  return env.VITE_LIBRARY_V2_ENABLED === 'true';
}
